import React, { useEffect, useRef, useState } from 'react'
import csvThumbnail from "../../../../../../assets/svg/csv-thumb.svg";
import { getProgressWidth } from '../../../../../../utils/campaignEdit';
import "./UploadProgressItem.scss";
import { getMediaThumbnailValue, getMediaType, getThumbnailForMedia, splitFilename } from '../../../../../../utils/mediaUtil';
import { MEDIA_TYPE_FOR_MEDIA_THUMBNAIL } from '../../../../../../consts/MediaLibrary';

const QA_ID_PREFIX = "UploadProgressItem";

function UploadProgressItem({
    file,
    progress,
    id,
}) {
    
    const barWidthRef = useRef(0);
    const [barWidth, setBarWidth] = useState(0);
    const [mediaType, setMediaType] = useState(MEDIA_TYPE_FOR_MEDIA_THUMBNAIL.UNKNOWN_FILE.value);
    

    useEffect(() => {
        setBarWidth(barWidthRef?.current?.offsetWidth);
    }, []);

    useEffect(() => {
        
        const filename = file.actualFilename || file.name;
        
        const name = splitFilename(filename);
        
        const extension = name.extension ? name.extension.toLowerCase() : "";
        setMediaType(getMediaThumbnailValue(extension));
    }, [file?.filename]);

    return (
        <div
            id={`${QA_ID_PREFIX}-${id}`}
            className="csv-files-list"
            data-testid={`${QA_ID_PREFIX}-container`}
        >
            <img
                style={{
                    height: "30px",
                    width: "30px",
                }}
                alt={file.name}
                src={getThumbnailForMedia(mediaType)}
                data-testid={`${QA_ID_PREFIX}-thumbnail`}
            />
            <div
                style={{display: "flex", flexDirection: 'column', flex: 1}}
                data-testid={`${QA_ID_PREFIX}-content`}
            >
                <div
                    className='file-upload-progress-bar'
                    style={{width: `${getProgressWidth(progress, barWidth)}px`}}
                    data-testid={`${QA_ID_PREFIX}-progress-bar`}
                ></div>
                <div
                    ref={barWidthRef}
                    className="file-name"
                    data-testid={`${QA_ID_PREFIX}-file-name`}
                >
                    {file.name}
                </div>
            </div>
            <div data-testid={`${QA_ID_PREFIX}-spacer`}></div>
        </div>
    )
}

export default UploadProgressItem;